import { Component } from "react";
import Fetch from "utils/fetch";
import Session from "utils/user-storage";
import Header from "components/header";
import Loading from "components/center-loading";
import ScreenDefault from "./components/screen-default";
import DateRangerPicker from "components/date-range-picker";
import { SelectBox } from "components/uikit-adapter/index"
import { Row, Col } from "react-flexbox-grid";
import intl from "react-intl-universal";
import "./relatorios.css";
import { formatErrorMessage } from "utils/handle-error";
import DadosRelatorios from "./dados-relatorios";
import TipoUsuario from "../../models/usuarios/tipo-usuario";
import moment from "moment";
import { downloadFile, generateQueryParams } from "../../utils/custom-functions";
import SnackBar from "material-ui/Snackbar";
import ProductionPlanReportDisclaimer from "../../components/production-plan-report-disclaimer";
import { usesSharedWeeklyForecastWithSupplier, usesTmsIntegration } from "utils/validations-general-settings";
import { isUseFilterDefault } from 'utils/user';
import { searchBusinessUnit, searchCountries, searchSuppliers, searchMaterials } from 'services/filters.service';
import {fetchStatusSuggestion} from 'services/suggestion/suggestion.service';
import HourRange from 'components/hour-range'
import Button from "components/button";
import { Switcher } from "components/toggle";
class Relatorios extends Component {
  constructor() {
    super();

    this.state = {
      data: [],
      reportSelected: {},
      showMsg: false,
      textMsg: "",
      titleMsg: "",
      isFetching: false,
      centersList: [],
      stagesList: [],
      stagesVolumeList: [],
      stagesSuggestionList: [],
      walletsList: [],
      countries: [],
      suppliersList:[],
      materialsList:[],
      currentPeriodDatesList: [],
      invalidPeriod: null,
      includePickUpLocation: false,
      includeDeliveryLocation: false,
      filterSelected: {
        dataColetaDe: "",
        dataColetaAte: "",
        dataEntregaDe: "",
        dataEntregaAte: "",
        productionDateFrom: "",
        productionDateTo: "",
        deliveryHourFrom:"",
        deliveryHourTo:"",
        centers: [],
        etapa: 0,
        suggetionStage: [],
        carteiras: [],
        currentPeriodDate: 1,
        countries: [],
        suppliers: [],
        materials: []
      },
    };
  }

  componentDidMount() {
    this.mountListOfCurrentPeriodDates();
    this.configureReports();
    this.searchCountries();
    this.searchCenters();
    this.searchEtapa();
    this.searchEtapaVolume();
    this.searchEtapaSuggestion();
    this.searchWallets();
    this.searchSuppliers();
    this.searchMaterials();
  }

  mountListOfCurrentPeriodDates() {
    const lastMonth = intl.get("reports.filters.lastMonth");
    const last = intl.get("reports.filters.last");
    const months = intl.get("reports.filters.months");
    const currentPeriodDatesList = [
      { Id: 1, Description: `${lastMonth}` },
      { Id: 3, Description: `${last} 3 ${months}` }
    ];

    this.setState({ currentPeriodDatesList });
  }

  searchCountries = () => {
    this.startFetching()
    searchCountries(isUseFilterDefault())
      .then((response) => this.processData("countries", response))
      .catch((error) => this.proccessErro(error))
      .finally(this.stopFetching());
  }

  searchCenters = () => {
    this.startFetching();
    searchBusinessUnit(isUseFilterDefault())
      .then((response) => this.processData("centersList", response))
      .catch((error) => this.proccessErro(error))
      .finally(this.stopFetching());
  };

  searchEtapaVolume = () => {
    this.startFetching()
    Fetch.get('/volume-orders/status')
      .then((response) => this.processData("stagesVolumeList", response.data))
      .catch((e) => this.proccessErro(e))
      .finally(this.stopFetching(false));
  }

  searchEtapaSuggestion = () => {
    this.startFetching()
    fetchStatusSuggestion()
      .then((response) => this.processData("stagesSuggestionList", response))
      .catch((e) => this.proccessErro(e))
      .finally(this.stopFetching(false));
  }

  searchEtapa = () => {
    this.startFetching();
    Fetch.get(`/status/getEtapas`)
      .then((response) => this.processData("stagesList", response.data))
      .catch((e) => this.proccessErro(e))
      .finally(this.stopFetching(false));
  };

  searchWallets = () => {
    this.startFetching();
    Fetch.get(`/material-groups:all`)
      .then((response) => this.processData("walletsList", response.data))
      .catch((e) => this.proccessErro(e))
      .finally(this.stopFetching());
  };

  searchSuppliers = () => {
    this.startFetching();
    searchSuppliers(isUseFilterDefault())
      .then((response) => this.processData("suppliersList", response))
      .catch((e) => this.proccessErro(e))
      .finally(this.stopFetching());
  };

  searchMaterials = () => {
    this.startFetching();
    searchMaterials(isUseFilterDefault())
      .then((response) => this.processData("materialsList", response))
      .catch((e) => this.proccessErro(e))
      .finally(this.stopFetching());
  };

  processData = (prop, data) => {
    this.setState({
      [prop]: data,
    });
  };

  selectReport = (reportSelected) => {
    this.setState({
      reportSelected,
      includePickUpLocation: false,
      includeDeliveryLocation: false,
    });
  };

  updateDataRange = (prop, value, dateType) => {
    let campo = "";
    if (dateType === "pickUpDate") {
      if (prop === "dataDe") {
        campo = "dataColetaDe";
      } else {
        campo = "dataColetaAte";
      }
    } else if (dateType === "deliveryDate") {
      if (prop === "dataDe") {
        campo = "dataEntregaDe";
      } else {
        campo = "dataEntregaAte";
      }
    } else if (dateType === "productionDate") {
      if (prop === "dataDe") {
        campo = "productionDateFrom";
      } else {
        campo = "productionDateTo";
      }
    }

    this.setState(prevState => ({
      filterSelected: {
        ...prevState.filterSelected,
        [campo]: value,
      },
    }));
  };

  updateHourRange = (field, value) =>{
    this.setState(prevState => ({
      filterSelected: {
        ...prevState.filterSelected,
        [field]: value,
      },
    }));
  }

  changeValueFilters = (prop, value) => {
    this.setState(prevState => ({
      filterSelected: {
        ...prevState.filterSelected,
        [prop]: value,
      },
    }));
  };

  changeFilterValues = (prop, event) => {
    const value = [];
    event.map((v) => value.push(v));
    this.setState(prevState => ({
      filterSelected: {
        ...prevState.filterSelected,
        [prop]: value,
      },
    }));
  };

  cleanFilters = () => {
    this.setState({
      filterSelected: {
        dataColetaDe: "",
        dataColetaAte: "",
        dataEntregaDe: "",
        dataEntregaAte: "",
        carteiras: [],
        centers: [],
        suppliers: [],
        etapa: 0,
        currentPeriodDate: 6,
        countries: [],
        deliveryHourFrom:"",
        deliveryHourTo:"",
        materials: [],
        suggetionStage: []
      },
      includePickUpLocation: false,
      includeDeliveryLocation: false,
    });
  };

  shouldShowLocationToggles = () => [
    DadosRelatorios.Pedidos.ReportName,
    DadosRelatorios.Volumes.ReportName,
    DadosRelatorios.Sugestoes.ReportName,
  ].includes(this.state.reportSelected?.ReportName);

  downloadReport = () => {
    const report = this.state.reportSelected;
    const datafile = moment(new Date()).format("YYYYMMDD_HHmmss");
    const reportFileName = `${report.ReportName}_${datafile}.csv`;

    if (report.ReportName === 'ORDERS_REPORT') {
      this.downloadOrderReport(report, reportFileName);
    } else if (report.ReportName === 'VOLUME_ORDERS_REPORT') {
      this.downloadOrderVolumeReport(report, reportFileName)
    }
    else if (report.ReportName ===  DadosRelatorios.Sugestoes.ReportName){
      this.downloadSuggestionReport(report, reportFileName);
    }
    else {
      this.downloadReports(report, reportFileName);
    }
  };

  downloadOrderVolumeReport = (report, reportFileName) => {
    this.startFetching();

    const filter = this.state.filterSelected;

    const params = {
      CurrentPeriodDate: filter.currentPeriodDate,
      PickupDateMin: filter.dataColetaDe,
      PickupDateMax: filter.dataColetaAte,
      DeliveryDateMin: filter.dataEntregaDe,
      DeliveryDateMax: filter.dataEntregaAte,
      VolumeOrderStatus: [
        filter.etapa
      ],
      Countries: [],
      Suppliers: [],
      BusinessUnits: [],
      MaterialGroup: [],
      IncludePickUpLocation: this.state.includePickUpLocation,
      IncludeDeliveryLocation: this.state.includeDeliveryLocation,
    };
  
    filter.countries.forEach(function (element) {
      params.Countries.push(element.Id);
    });
    filter.suppliers.forEach(function (element) {
      params.Suppliers.push(element.Id);
    });
    filter.centers.forEach(function (element) {
      params.BusinessUnits.push(element.Id);
    });
    filter.carteiras.forEach(function (element) {
      params.MaterialGroup.push(element.Id);
    });

    const url = `${report.Url}?${generateQueryParams(params)}`;

    Fetch.get(url)
      .then((response) => { downloadFile(reportFileName, "csv", response.data); })
      .catch((e) => this.proccessErro(e))
      .finally(() => this.stopFetching());
  };

  downloadOrderReport = (report, reportFileName) => {
    this.startFetching();

    const filter = this.state.filterSelected;

    const params = {
      CurrentPeriodDate: filter.currentPeriodDate,
      PickupDateMin: filter.dataColetaDe,
      PickupDateMax: filter.dataColetaAte,
      DeliveryDateMin: filter.dataEntregaDe,
      DeliveryDateMax: filter.dataEntregaAte,
      OrderStatus: [
        filter.etapa
      ],
      Countries: [],
      Suppliers: [],
      BusinessUnits: [],
      MaterialGroup: [],
      IncludePickUpLocation: this.state.includePickUpLocation,
      IncludeDeliveryLocation: this.state.includeDeliveryLocation,
    };

    filter.countries.forEach(function (element) {
      params.Countries.push(element.Id);
    });
    filter.suppliers.forEach(function (element) {
      params.Suppliers.push(element.Id);
    });
    filter.centers.forEach(function (element) {
      params.BusinessUnits.push(element.Id);
    });
    filter.carteiras.forEach(function (element) {
      params.MaterialGroup.push(element.Id);
    });

    const url = `${report.Url}?${generateQueryParams(params)}`;

    Fetch.get(url)
      .then((response) => { downloadFile(reportFileName, "csv", response.data); })
      .catch((e) => this.proccessErro(e))
      .finally(() => this.stopFetching());
  };

  downloadSuggestionReport = (report, reportFileName) => {
    this.startFetching();

    const filter = this.state.filterSelected;

    const params = {
      SuggestionStatus:[],
      Countries: [],
      Suppliers: [],
      BusinessUnits: [],
      MaterialNumbers: [],
      MaterialGroups: [],
      CurrentPeriodDate: filter.currentPeriodDate,
      DeliveryDateMin: filter.dataEntregaDe,
      DeliveryDateMax: filter.dataEntregaAte,
      DeliveryTimeMin: filter.deliveryHourFrom,
      DeliveryTimeMax: filter.deliveryHourTo,
      IncludePickUpLocation: this.state.includePickUpLocation,
      IncludeDeliveryLocation: this.state.includeDeliveryLocation,
    };

    filter.suggetionStage.forEach(function (element) {
      params.SuggestionStatus.push(element.Id);
    });
    filter.countries.forEach(function (element) {
      params.Countries.push(element.Id);
    });
    filter.suppliers.forEach(function (element) {
      params.Suppliers.push(element.Id);
    });
    filter.centers.forEach(function (element) {
      params.BusinessUnits.push(element.Id);
    });
    filter.materials.forEach(function (element) {
      params.MaterialNumbers.push(element.MaterialNumber);
    });
    filter.carteiras.forEach(function (element) {
      params.MaterialGroups.push(element.Id);
    });

    const url = `${report.Url}?${generateQueryParams(params)}`;

    Fetch.get(url)
      .then((response) => { downloadFile(reportFileName, "csv", response.data); })
      .catch((e) => this.proccessErro(e))
      .finally(() => this.stopFetching());
  };

  downloadReports = (report, reportFileName) => {
    this.startFetching();
    const request = report.Url === DadosRelatorios.StatusEstoque.Url
      // The stock status export does not accept a request body in the backend contract.
      ? Fetch.post(report.Url)
      : Fetch.post(report.Url, {
        ...this.state.filterSelected,
        carteiras: this.state.filterSelected.carteiras.map(x => x.Id),
        centers: this.state.filterSelected.centers.map(x => x.Id)
      });

    request
      .then((response) => { downloadFile(reportFileName, "csv", response.data); })
      .catch((e) => this.proccessErro(e))
      .finally(() => this.stopFetching());
  };

  startFetching = () => {
    this.setState({
      isFetching: true,
    });
  };

  stopFetching = () => {
    this.setState({
      isFetching: false,
    });
  };

  proccessErro = (exception) => {
    this.setState({
      showMsg: true,
      titleMsg: "Erro",
      textMsg: formatErrorMessage(exception)
    });
  };

  handleClose = () => {
    this.setState({ showMsg: false });
  };

  renderOrderReport = (data) => {
    data.push(DadosRelatorios.Pedidos);
  }

  renderVolumeOrderReport = (data) => {
    data.push(DadosRelatorios.Volumes);
  }

  renderInventoryStatusReport = (data) => {
    if (Session.get().TipoUsuario === TipoUsuario.Ambev) {
      data.push({ ...DadosRelatorios.StatusEstoque, ReportName: intl.get("commons.statusStock") });
    }
  };

  renderVolumeOriginatedOrderReport = (data) => {
    if (usesTmsIntegration()) {
      data.push(DadosRelatorios.PedidoOrigemVolume)
    }
  }

  renderProductionPlanReport = (data) => {
    if (Session.get().TipoUsuario === TipoUsuario.Fornecedor && usesSharedWeeklyForecastWithSupplier()) {
      data.push(DadosRelatorios.PlanejamentoProducao)
    }
  };

  renderSuggestionReport = (data) => {
    data.push(DadosRelatorios.Sugestoes);
  }

  configureReports = () => {
    const data = [];

    this.renderOrderReport(data);
    this.renderVolumeOrderReport(data);
    this.renderInventoryStatusReport(data);
    this.renderVolumeOriginatedOrderReport(data);
    this.renderProductionPlanReport(data);
    this.renderSuggestionReport(data)

    this.setState({
      data,
      reportSelected: data[0],
    });
  };

  reportName = (name) => {
    let title = "";
    switch (name) {
      case "Pedidos":
        title = intl.get("reports.actions.reportRequest");
        break;
      case "Volumes":
        title = intl.get("reports.actions.reportVolumeOrder")
        break;
      case "Pedidos Originados Por Volume":
        title = intl.get("reports.actions.requestDeliverySourceVol");
        break;
      case "Status do Estoque":
        title = intl.get("reports.actions.requestSourceVol");
        break;
      case DadosRelatorios.PlanejamentoProducao.Nome:
        title = intl.get("reports.actions.requestProductionPlan");
        break;
      case DadosRelatorios.Sugestoes.Nome:
        title = intl.get("reports.actions.reportSuggestion");
        break;
      default:
        break;
    }
    return title
  };

  screenLeft = () => {
    const { data, reportSelected } = this.state;

    return (
      <div className="left-content">
        <div className="report-span-text font-title">
          <span>{intl.get("reports.actions.reportList")}</span>
        </div>
        {data.map((v, i) => (
          <button
            className={
              v.ReportName == reportSelected.ReportName
                ? "left-list-report report-selected"
                : "left-list-report"
            }
            key={i}
            onClick={() => this.selectReport(v)}
          >
            <span
              className={`report-span-text font-list-report ${v.ReportName}`}
            >
              {this.reportName(v.Nome)}
            </span>
          </button>
        ))}
      </div>
    );
  };

  screenRight = () => {
    const { reportSelected } = this.state;

    return (
      <div className="right-content">
        <div>
          <div>
            <span className="report-span-text font-title">
              {this.reportName(reportSelected.Nome)}
            </span>
          </div>
          <Row>
            <Col xs={12} lg={12} md={12}>
              <hr className="filter-divisor" />
            </Col>
          </Row>

          {this.mountFilters(reportSelected.ReportName).map((f, i) => (
            <div>
              <Row key={i}>
                <Col xs={12} lg={12} md={12}>
                  {f}
                </Col>
              </Row>
            </div>
          ))}
        </div>

        <Row>
          <Col xs={12} lg={12} md={12}>
            <Row>
              <Col xs={12} lg={12} md={12}>
                <hr className="filter-divisor" />
              </Col>
            </Row>
            <div className="footer-dialog-buttons">
              <Row>
                <Col xs={6} lg={6} md={6}>
                  <div title={intl.get("filters.cleanSearch")}>
                    <Button
                      className="button"
                      onClick={this.cleanFilters}
                      buttonType="default"
                      value={intl.get("filters.cleanFilter")}
                    />
                  </div>
                </Col>
                <Col xs={6} lg={6} md={6}>
                  {this.shouldShowLocationToggles() && (
                    <div className="report-location-toggles">
                      <Switcher
                        label={intl.get("reports.actions.includePickUpLocation")}
                        name="include-pick-up-location"
                        value={this.state.includePickUpLocation}
                        onChange={(target) => this.setState({ includePickUpLocation: target.checked })}
                      />
                      <Switcher
                        label={intl.get("reports.actions.includeDeliveryLocation")}
                        name="include-delivery-location"
                        value={this.state.includeDeliveryLocation}
                        onChange={(target) => this.setState({ includeDeliveryLocation: target.checked })}
                      />
                    </div>
                  )}
                  <div
                    title={`${intl.get("reports.actions.downloadToolTip")} ${this.reportName(reportSelected.Nome)}`}
                  >
                    <Button
                      className="button"
                      onClick={this.downloadReport}
                      buttonType="primary"
                      value="Download"
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  countriesFilter = () => {
    return <SelectBox
        required
        label={intl.get('commons.country')}
        placeholder={intl.get('commons.country')}
        name='Pais'
        value={this.state.filterSelected.countries}
        valueKey='Id'
        labelKey='Description'
        onChange={(event) => this.changeFilterValues("countries", event)}
        options={this.state.countries}
        width="100%"
        clearable
        multi
        searchable
        className="countries-filter"
      />

  };

  centerFilter = () => {
    return (
      <SelectBox
        required
        name="Centros"
        label={intl.get("commons.brewery")}
        placeholder={intl.get("reports.actions.selectBrewery")}
        valueKey="Id"
        labelKey="Description"
        value={this.state.filterSelected.centers}
        options={this.state.centersList}
        onChange={(event) => this.changeFilterValues("centers", event)}
        searchable
        openOnFocus
        multi
        className="brewery-filter"
      />
    );
  };

  supplierFilter = () => {
    return (
      <SelectBox
        required
        name="Suppliers"
        label={intl.get("commons.supplier")}
        placeholder={intl.get("reports.actions.selectSupplier")}
        valueKey="Id"
        labelKey="Description"
        value={this.state.filterSelected.suppliers}
        options={this.state.suppliersList}
        onChange={(event) => this.changeFilterValues("suppliers", event)}
        searchable
        openOnFocus
        multi
        className="supplier-filter"
      />
    );
  };

  stageFilter = (reportName) => {
    return (
      <SelectBox
        required
        name="Etapa"
        label={intl.get("requestOrders.step")}
        placeholder={intl.get("reports.actions.selectStage")}
        valueKey="Id"
        labelKey="Description"
        value={this.state.filterSelected.etapa}
        options={this.getStageOptionsByReportType(reportName)}
        onChange={(event) =>
          this.changeValueFilters("etapa", event ? event.Id : 0)
        }
        searchable
        openOnFocus
        clearable
        className="stage-filter"
      />
    );
  };

  stageMultiFilter = (reportName) => {
    return (
      <SelectBox
        required
        name="Etapa-Multi"
        label={intl.get("requestOrders.step")}
        placeholder={intl.get("reports.actions.selectStage")}
        valueKey="Id"
        labelKey="Description"
        value={this.state.filterSelected.suggetionStage}
        options={this.getStageOptionsByReportType(reportName)}
        onChange={(event) => this.changeFilterValues("suggetionStage", event)}
        searchable
        openOnFocus
        multi
        clearable
        className="stage-multi-filter"
      />
    );
  };

  getStageOptionsByReportType = (reportName) =>{

    switch(reportName){
      case DadosRelatorios.Pedidos.ReportName:
        return this.state.stagesList; 
      case DadosRelatorios.Volumes.ReportName:
        return this.state.stagesVolumeList;
      case DadosRelatorios.Sugestoes.ReportName:
        return this.state.stagesSuggestionList;
      default:
        return [];
    }
  }

  walletFilter = () => {
    return (
      <SelectBox
        required
        name="Carteiras"
        label={intl.get("commons.wallet")}
        placeholder={intl.get("reports.actions.selectWallet")}
        valueKey="Id"
        labelKey="Description"
        value={this.state.filterSelected.carteiras}
        options={this.state.walletsList}
        onChange={(event) => this.changeFilterValues("carteiras", event)}
        searchable
        openOnFocus
        multi
        className="wallet-filter"
      />
    );
  };

  currentPeriodDateFilter = () => {
    return (
      <SelectBox
        required
        name="CurrentPeriodDate"
        label={intl.get("reports.filters.currentPeriodDate")}
        valueKey="Id"
        labelKey="Description"
        value={this.state.filterSelected.currentPeriodDate}
        options={this.state.currentPeriodDatesList}
        onChange={(event) =>
          this.changeValueFilters("currentPeriodDate", event ? event.Id : 0)
        }
        searchable
        openOnFocus
      />
    );
  };

  collectDateFilter = () => {
    return (
      <DateRangerPicker
        title={intl.get("commons.colDate")}
        dataDe={this.state.filterSelected.dataColetaDe}
        dataAte={this.state.filterSelected.dataColetaAte}
        handleChange={(x, y) => this.updateDataRange(x, y, "pickUpDate")}
        className="collect-date-filter"
      />
    );
  };

  deliveryDateFilter = () => {
    return (
      <DateRangerPicker
        title={intl.get("commons.deliveryDate")}
        dataDe={this.state.filterSelected.dataEntregaDe}
        dataAte={this.state.filterSelected.dataEntregaAte}
        handleChange={(x, y) => this.updateDataRange(x, y, "deliveryDate")}
        className="delivery-date-filter"
      />
    );
  };

  productionDateFilter = () => {
    return (
      <DateRangerPicker
        title={intl.get("commons.productionDate")}
        dataDe={this.state.filterSelected.productionDateFrom}
        dataAte={this.state.filterSelected.productionDateTo}
        dataMin={moment().format("YYYY-MM-DD")}
        handleChange={(x, y) => this.updateDataRange(x, y, "productionDate")}
        className="production-date-filter"
      />
    );
  };

  materialsFilter = () => {
    return (
      <SelectBox
        required
        name="materials"
        label={intl.get("commons.material")}
        placeholder={intl.get("commons.material")}
        valueKey="MaterialNumber"
        labelKey="Description"
        value={this.state.filterSelected.materials}
        options={this.state.materialsList}
        onChange={(event) => this.changeFilterValues("materials", event)}
        searchable
        openOnFocus
        multi
        className="materials-filter"
      />
    );
  };

  deliveryHourFilter = () => {
    return(
      <HourRange
      labelFrom={intl.get("commons.deliveryTimeFrom")}
      labelTo={intl.get("commons.deliveryTimeTo")}
      hourFrom={this.state.filterSelected.deliveryHourFrom}
      hourTo={this.state.filterSelected.deliveryHourTo}
      onChangeDeliveryTimeMin={value => this.updateHourRange("deliveryHourFrom", value)}
      onChangeDeliveryTimeMax={value => this.updateHourRange("deliveryHourTo", value)}
      onRangeIsValid={value => this.validateRangePeriods(value)}
      className="hour-range-filter"
    />
    )
  }

  validateRangePeriods = (value) => {
    this.setState({
      invalidPeriod: value
    })
  }

  noFilters = () => {
    return (
      <div>
        <span className="report-span-text font-list-report">
          {intl.get("filters.withoutFilter")}
        </span>
      </div>
    );
  };

  mountFilters = (reportName) => {
    const filters = [];
    switch (reportName) {
      case DadosRelatorios.Pedidos.ReportName:
      case DadosRelatorios.Volumes.ReportName:
        filters.push(this.stageFilter(reportName));
        filters.push(this.countriesFilter())
        filters.push(this.supplierFilter());
        filters.push(this.centerFilter());
        filters.push(this.walletFilter());
        filters.push(this.currentPeriodDateFilter());
        filters.push(this.collectDateFilter());
        filters.push(this.deliveryDateFilter());
        break;
      case DadosRelatorios.PedidoOrigemVolume.ReportName:
        filters.push(this.stageFilter());
        filters.push(this.walletFilter());
        filters.push(this.collectDateFilter());
        filters.push(this.deliveryDateFilter());
        break;
      case DadosRelatorios.PlanejamentoProducao.ReportName:
        filters.push(this.centerFilter());
        filters.push(this.walletFilter());
        filters.push(this.productionDateFilter());
        filters.push(<ProductionPlanReportDisclaimer />);
        break;
      case DadosRelatorios.Sugestoes.ReportName:
        filters.push(this.stageMultiFilter(reportName));
        filters.push(this.countriesFilter())
        filters.push(this.supplierFilter());
        filters.push(this.centerFilter());
        filters.push(this.materialsFilter());
        filters.push(this.walletFilter());
        filters.push(this.currentPeriodDateFilter());
        filters.push(this.deliveryDateFilter());
        filters.push(this.deliveryHourFilter());
        break;
      default:
        break;
    }
    if (filters.length <= 0) {
      filters.push(this.noFilters());
    }

    return filters;
  };

  render() {
    const { isFetching } = this.state;

    return (
      <div>
        <Loading isLoading={isFetching} />
        <Header title={intl.get("reports.header.title")} />

        <ScreenDefault
          screenLeft={this.screenLeft()}
          screenRight={this.screenRight()}
        />
        <SnackBar
          message={this.state.textMsg}
          open={this.state.showMsg}
          autoHideDuration={3000}
          onRequestClose={this.handleClose}
        />
      </div>
    );
  }
}

export default Relatorios;
